/* knowledge-cards-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./knowledge-cards-header.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIntl } from 'react-intl-next';
import { IconButton, LinkIconButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import DepartmentIcon from '@atlaskit/icon/core/department';
import EmailIcon from '@atlaskit/icon/core/email';
import LocationIcon from '@atlaskit/icon/core/location';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import TeamsAvatar from '@atlaskit/teams-avatar';
import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../common/controller/analytics';
import { messages } from '../messages';
import { onKnowledgeCardLinkClick } from './analytics';
import { KnowledgeCardsTopics } from './knowledge-cards-topics';
import { KnowledgeCardsPicture } from './styled';
import { KnowledgeCardsIntentType } from './types';
import { useTeamsAppLinks } from './use-teams-app-links';
import { onEmailCopy } from './util';
var styles = {
  knowledgeCardsPersonHeaderWrapper: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k",
  knowledgeCardsTeamHeaderWrapper: "_ca0qutpp _19bvv47k _u5f3v47k _n3tdutpp",
  knowledgeCardsPrimaryInfoWrapper: "_1e0c1txw _1bsb1osq _4t3i1osq _2lx21bp4 _1bah1h6o",
  knowledgeCardsButtonsWrapper: "_ca0qu2gc"
};
export var KnowledgeCardsHeader = function KnowledgeCardsHeader(props) {
  var type = props.type,
    name = props.name,
    accountId = props.accountId,
    email = props.email,
    avatarUrl = props.avatarUrl,
    profileUrl = props.profileUrl,
    jobTitle = props.jobTitle,
    department = props.department,
    location = props.location,
    time = props.time;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var isPerson = type === KnowledgeCardsIntentType.PERSON;
  var subText = isPerson ? [jobTitle, department].filter(function (text) {
    return !!text;
  }).join(', ') : formatMessage(messages.knowledge_cards_team_subheader);
  var trimmedSubText = subText.length > 250 ? "".concat(subText.slice(0, 250), "...") : subText;
  var timeAndLocationComponent = isPerson && (location || time) && /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: "color.text.subtlest"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(LocationIcon, {
    label: ""
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, location && /*#__PURE__*/React.createElement(Text, null, location), time && location && /*#__PURE__*/React.createElement(Text, null, "\u2022"), time && /*#__PURE__*/React.createElement(Text, null, time))));
  var tooltipOptions = {
    position: 'bottom',
    content: formatMessage(messages.knowledge_cards_copy_email_address),
    hideTooltipOnClick: true
  };
  var cloudId = commonAttributes.cloudId,
    sessionId = commonAttributes.sessionId;
  var showAITopics = isPerson && fg('kd_topics_in_person_card');
  var _useTeamsAppLinks = useTeamsAppLinks({
      type: type,
      currentUserId: accountId !== null && accountId !== void 0 ? accountId : '',
      cloudId: cloudId,
      teamId: type === KnowledgeCardsIntentType.TEAM ? props.teamId : undefined
    }),
    profileHref = _useTeamsAppLinks.profileHref,
    profileOnNavigate = _useTeamsAppLinks.profileOnNavigate;
  var viewText = isPerson ? messages.ai_answer_who_questions_view_profile : messages.knowledge_cards_view_team;
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    xcss: isPerson ? styles.knowledgeCardsPersonHeaderWrapper : styles.knowledgeCardsTeamHeaderWrapper
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignInline: "start",
    alignBlock: "center",
    grow: "fill"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.200",
    alignBlock: "center"
  }, !isPerson && fg('team-avatar-search-card') ? /*#__PURE__*/React.createElement(TeamsAvatar, {
    size: "xlarge",
    src: avatarUrl || undefined,
    name: name
  }) : /*#__PURE__*/React.createElement(KnowledgeCardsPicture, {
    src: avatarUrl || '',
    alt: name
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.knowledgeCardsPrimaryInfoWrapper
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium"
  }, name), trimmedSubText && /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: "color.text.subtlest"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, isPerson && /*#__PURE__*/React.createElement(DepartmentIcon, {
    label: ""
  }), " ", /*#__PURE__*/React.createElement(Text, null, trimmedSubText))), timeAndLocationComponent, showAITopics && /*#__PURE__*/React.createElement(KnowledgeCardsTopics, {
    cloudId: cloudId,
    userId: accountId !== null && accountId !== void 0 ? accountId : '',
    userName: name,
    sessionId: sessionId,
    v2styles: true
  }))))), /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    xcss: styles.knowledgeCardsButtonsWrapper
  }, !!email && /*#__PURE__*/React.createElement(IconButton, {
    icon: function icon(props) {
      return /*#__PURE__*/React.createElement(EmailIcon, _extends({}, props, {
        color: "var(--ds-icon, #292A2E)"
      }));
    },
    label: formatMessage(messages.ai_answer_who_questions_hover_email_icon),
    onClick: function onClick() {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'header-copy-email'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.COPY_CLICKED
      });
      onEmailCopy(email);
    },
    isTooltipDisabled: false,
    tooltip: tooltipOptions
  }), /*#__PURE__*/React.createElement(LinkIconButton, {
    icon: ArrowRightIcon,
    label: formatMessage(viewText),
    href: fg('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
    onClick: function onClick(e) {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'header-view-profile'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.VIEW_PROFILE_CLICKED
      });
      if (fg('platform-adopt-teams-nav-config')) {
        profileOnNavigate(e);
      }
    }
  })));
};